import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ModuleListRes;
export const ModuleListTodo = createAsyncThunk('ModuleList', async (data) => {

    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'superadmin/master_module',
            // params: {
            //         "uid":localStorage.getItem('user_id')
            // },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') },

        })
        return ModuleListRes = res.data

    } catch (error) {
        return ModuleListRes = error.response.data
    }
});

const ModuleListSlice = createSlice({
    name: 'ModuleList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ModuleListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ModuleListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ModuleListSlice.reducer; 